export default __webpack_public_path__ + "static/media/Clotzr_desktop.81361076.png";